import React, { useMemo } from "react";
import { ReactComponent as UsdtIcon } from "images/coins/usdtIconRound.svg";
import { ReactComponent as EthIcon } from "images/coins/ethIcon.svg";
import { ReactComponent as EthIconRound } from "images/coins/ethIconRound.svg";
import { ReactComponent as UsdcIconRound } from "images/coins/usdcIconRound.svg";
import { ReactComponent as TronIconRound } from "images/coins/tronIconRound.svg";
import { ReactComponent as RubIcon } from "images/coins/rubFlag.svg";

import styles from "./cryptIcon.module.css";

interface CryptoIconProps {
  currency: string;
  squareBg?: boolean;
  size?: "sm" | "md" | "lg" | "xl" | "2xl" | "3xl" | "4xl";
  squareSize?: "sm" | "md" | "lg" | "xl" | "2xl" | "3xl" | "4xl";
  ethIconRound?: boolean;
}

const ICON_COMPONENTS: Record<string, React.ComponentType<{ className?: string }>> = {
  RUB: RubIcon,
  USDT: UsdtIcon,
  USDC: UsdcIconRound,
  TRX: TronIconRound,
  ETH_ROUND: EthIconRound,
  ETH: EthIcon,
};

export const CryptoIcon: React.FC<CryptoIconProps> = React.memo(({
  currency = "",
  squareBg = false,
  size,
  squareSize = "3xl",
  ethIconRound = false,
}) => {
  const iconSize = size || (squareBg && "xl") || "lg";
  const sizeClass = styles[`icon-${iconSize}`];

  // TODO - remove ETH_ROUND
  const iconType = useMemo(
    () => (currency.toUpperCase() === "ETH" && ethIconRound ? "ETH_ROUND" : currency.toUpperCase()),
    [currency, ethIconRound]
  );

  const IconComponent = ICON_COMPONENTS[iconType];

  if (!IconComponent) return null;

  if (squareBg) {
    return (
      <div className={`${styles.square} ${styles[`icon-${squareSize}`]} bg-basic-200`}>
        <IconComponent className={sizeClass} />
      </div>
    );
  }

  return <IconComponent className={sizeClass} />;
});
